import ApiService from './api.service'

const FormService = {

  /***
   * Get Location
   * @returns {*}
   */
  get (rowkey) {
    return ApiService.get('location', rowkey)
  },
  /***
   * Assign form to an account
   * @param {string} payload.lat latitude of the point
   * @param {string} payload.lng longitude of the point
   * @param {string} payload.bypassRange bypass the access point range limits
   * @returns {*}
   */
  checkCoverage (payload) {
    const params = {
      ...payload,
    }
    return ApiService.post('location/check-coverage', params)
  },
}
export default FormService
